import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import '../styles/saveEditsReminderModal.scss';
import ButtonComponent from './ButtonComponent';
import CheckBox from './CheckBox';
import Popup from './Popup';
import { t } from 'i18next';
import { getImageSrc } from '../helper/imageBlobCache';
// localStorage key for the "don't remind me again" preference. When set to
// "1" the reminder is suppressed for this browser/profile.
export var SAVE_EDITS_REMINDER_SUPPRESSED_KEY = 'iwb.saveEditsReminderSuppressed';
export var isSaveEditsReminderSuppressed = function () {
    try {
        return window.localStorage.getItem(SAVE_EDITS_REMINDER_SUPPRESSED_KEY) === '1';
    }
    catch (_a) {
        return false;
    }
};
var setSuppressed = function (suppressed) {
    try {
        if (suppressed)
            window.localStorage.setItem(SAVE_EDITS_REMINDER_SUPPRESSED_KEY, '1');
        else
            window.localStorage.removeItem(SAVE_EDITS_REMINDER_SUPPRESSED_KEY);
    }
    catch (_a) {
        // localStorage may be unavailable (private mode, quota); ignore.
    }
};
var SaveEditsReminderModal = function (props) {
    var showModal = props.showModal, setShowModal = props.setShowModal, onContinue = props.onContinue, onSaveNow = props.onSaveNow;
    var _a = useState(false), dontRemind = _a[0], setDontRemind = _a[1];
    var close = function () {
        setSuppressed(dontRemind);
        setShowModal(false);
    };
    var handleContinue = function () {
        close();
        onContinue();
    };
    var handleSaveNow = function () {
        close();
        onSaveNow();
    };
    return (_jsx(Popup, { isOpen: showModal, onClose: function () {
            setSuppressed(dontRemind);
            setShowModal(false);
        }, ariaLabelledBy: "serm-title", children: _jsx("div", { className: "serm-container", children: _jsxs("div", { className: "serm-content", children: [_jsx("h1", { id: "serm-title", className: "serm-title", children: t('text.saveEditsReminderTitle') }), _jsx("hr", { className: "popupHr", "aria-hidden": "true" }), _jsx("div", { className: "serm-body", children: t('text.saveEditsReminderBody') }), _jsx("div", { className: "serm-checkboxRow", children: _jsx(CheckBox, { id: "saveEditsReminderDontRemind", checked: dontRemind, onClick: function () { return setDontRemind(function (prev) { return !prev; }); }, label: t('text.dontRemindMeAgain'), labelCSS: "serm-checkboxLabel", ariaLabel: t('text.dontRemindMeAgain') }) }), _jsxs("div", { className: "serm-buttons", children: [_jsx(ButtonComponent, { type: "textType1", text: t('text.continueEditing'), defaultCSS: "serm-btn serm-cancelBtn", normalCSS: "serm-cancelBtn", clickHandler: handleContinue }), _jsx(ButtonComponent, { type: "textType1", text: t('text.saveNow'), defaultCSS: "serm-btn serm-saveBtn", normalCSS: "serm-saveBtn", clickHandler: handleSaveNow })] }), _jsx("div", { className: "serm-footer", children: _jsx("img", { src: getImageSrc('./assets/images/popupColorPatch.svg'), tabIndex: -1, alt: "" }) })] }) }) }));
};
export default SaveEditsReminderModal;
